var _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgConnectSmsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.423 2.667h-7.18C7.006 2.667 6 3.617 6 4.788v14.424c0 1.171 1.005 2.121 2.244 2.121h7.18c1.238 0 2.243-.95 2.243-2.12V4.787c0-1.171-1.006-2.121-2.244-2.121zm-3.59 16.651c-.745 0-1.346-.568-1.346-1.273 0-.704.601-1.272 1.346-1.272.745 0 1.347.568 1.347 1.273 0 .704-.602 1.272-1.347 1.272z",
    fill: "url(#connect-sms-icon_svg__paint0_linear_7070_120619)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.423 2.667h-7.18C7.006 2.667 6 3.617 6 4.788v14.424c0 1.171 1.005 2.121 2.244 2.121h7.18c1.238 0 2.243-.95 2.243-2.12V4.787c0-1.171-1.006-2.121-2.244-2.121zm-3.59 16.651c-.745 0-1.346-.568-1.346-1.273 0-.704.601-1.272 1.346-1.272.745 0 1.347.568 1.347 1.273 0 .704-.602 1.272-1.347 1.272z",
    fill: "#A5BBD4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "connect-sms-icon_svg__paint0_linear_7070_120619",
    x1: 17.899,
    y1: 2.838,
    x2: 0.942,
    y2: 13.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.6
  })))));
}

export default __webpack_public_path__ + "./fonts/connect-sms-icon.aace29005aafdf1d20d248cac7fd9cc9.svg";
export { SvgConnectSmsIcon as ReactComponent };